export default "__VITE_ASSET__BEimxcA2__"